/* eslint-disable no-console, no-case-declarations, no-unused-vars */
// import axios from "axios";
import {apolloClient} from "@/setup/apollo-setup";
import {serverResponseStatusSet/* , error */} from '@/utils/notification';

import {
  GET_LIVECLASSSCHEDULES,
  GET_LIVECLASSSCHEDULES_CURRENT_USER,
} from '@/queries/modules/liveclass';

/**
 *  Action to Get Live Class Schedules
 *
 *   @param  {Object} context Vuex context object.
 *     @property {Vuex method (Function)} commit : "To commit a mutation"
 *
 */

export async function getLiveClassSchedules(context) {
  const {commit} = context;
  commit('setProcessing', true);

  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
    const {data} = await result;
    console.log(result);

    const liveclassSchedules = data.getLiveClassSchedules;
    commit("storeLiveclassSchedules", liveclassSchedules);

    // TODO: Handle after success;
    return {status: {success: true, error: false, message: ""}, data: liveclassSchedules};

  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
      commit('setError', serverResponseStatusSet(e.graphQLErrors[0].extensions));
    }
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getLiveClassSchedulesCurrentUser(context) {
  const {commit} = context;
  commit('setProcessing', true);

  try {
    const result = await apolloClient
      .query({
        query: GET_LIVECLASSSCHEDULES_CURRENT_USER,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
    const {data, error} = await result;
    commit('setProcessing', false);

    if (error) {
      commit('setError', error);
      return null;
    }

    return data.getLiveClassSchedulesCurrentUser;

  } catch (e) {
    commit('setProcessing', false);
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
      commit('setError', serverResponseStatusSet(e.graphQLErrors[0].extensions));
    }
    return null;
  }
}

export async function viewLiveClass(context, payload) {
  const {commit} = context;
  commit("setLiveClass", payload);
}
